import { render } from "./delBorder.vue?vue&type=template&id=b50ac18e&scoped=true"
import script from "./delBorder.vue?vue&type=script&lang=js"
export * from "./delBorder.vue?vue&type=script&lang=js"

import "./delBorder.vue?vue&type=style&index=0&id=b50ac18e&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50ac18e"]])

export default __exports__